import { Navigate } from 'react-router-dom';

const LabUserDataRedirect = () => <Navigate to="/my_map/user_data" replace />;

export default LabUserDataRedirect;
